<template>
  <div class="search-container">
    <div class="search-form">
      <a-form :labelCol="labelCol" ref="searchFrom">
        <div class="form-body">
          <div class="form-item1">
            <a-form-item label="邮箱/手机/第三方账号">
              <a-input
                v-model:value="modelRef.phoneNumber"
                class="item1"
                placeholder="请输入查询的邮箱/手机号/第三方账号"
                allowClear
              />
            </a-form-item>
            <a-form-item label="注册时间">
              <a-range-picker
                v-model:value="modelRef.time"
                class="item1"
                show-time
                :placeholder="['开始时间', '结束时间']"
              >
                <template #dateRender="{ current, today }">
                  <div class="ant-calendar-date">{{ current.date() }}</div>
                </template>
              </a-range-picker>
            </a-form-item>
            <a-form-item label="国家/地区">
              <a-select
                v-model:value="modelRef.country"
                class="item1"
                placeholder="请选择国家"
                show-search
                :default-active-first-option="true"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="fetching ? undefined : null"
                @search="fetchCountry"
                allowClear
              >
                <a-select-option
                  v-for="pro in countryData"
                  :key="pro.countryCode"
                >{{ pro.countryName }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form-item1">
            <a-form-item label="注册方式">
              <a-select
                v-model:value="modelRef.method"
                class="item1"
                placeholder="请选择注册方式"
                allowClear
              >
                <a-select-option v-for="item in methodData" :key="item.key">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="语种">
              <a-select v-model:value="modelRef.lang" class="item1" placeholder="请选择语种" allowClear>
                <a-select-option v-for="item in langData" :key="item.fullCode">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="注册类型">
              <a-select
                v-model:value="modelRef.device"
                class="item1"
                placeholder="请选择注册类型"
                allowClear
              >
                <a-select-option v-for="item in deviceData" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form-item2">
            <a-form-item label="utm_source">
              <a-input
                v-model:value="modelRef.utm_source"
                class="item1"
                placeholder="请输入渠道"
                allowClear
              />
            </a-form-item>
            <a-form-item label="utm_medium">
              <a-input
                v-model:value="modelRef.utm_medium"
                class="item1"
                placeholder="请输入媒介"
                allowClear
              />
            </a-form-item>
            <a-form-item label="utm_campaign">
              <a-input
                v-model:value="modelRef.utm_campaign"
                class="item1"
                placeholder="请输入标题"
                allowClear
              />
            </a-form-item>
            <a-form-item label="utm_content">
              <a-input
                v-model:value="modelRef.utm_content"
                class="item1"
                placeholder="请输入内容"
                allowClear
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </div>
    <div class="search-btn">
      <a-button type="primary" @click="onSubmit" :loading="loadingObj.loadingSearch">查询</a-button>
      <a-button
        style="margin-left: 10px;"
        @click="resetFields"
        :loading="loadingObj.loadingReset"
      >重置</a-button>
      <a-button
        style="margin-left: 10px;"
        @click="downloadChange"
        :loading="loadingObj.loadingDownload"
      >
        下载数据
      </a-button>
    </div>
    <div class="search-table">
      <div class="table-num">
        <div class="num-pre">
          <span class="pre-text">预注册总数量:</span>
          <span class="next-text">{{pageData.total}}</span>
        </div>
        <div class="num-pre margin">
          <span class="pre-text">筛选后预注册数量:</span>
          <span class="next-text">{{pageData.filterTotal}}</span>
        </div>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 'calc(950px + 50%)', y: 540 }"
        :pagination="false"
        :loading="loadingObj.loading"
      >
        <template #userType="{ text }">
          <span v-if="text === 1">手机号</span>
          <span v-if="text === 2">邮箱</span>
          <span v-if="text === 3">facebook</span>
        </template>
        <template #countryName="{ text }">
          <span v-if="!text">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #utmSource="{ text }">
          <span v-if="!text">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #utmMedium="{ text }">
          <span v-if="!text">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #utmCampaign="{ text }">
          <span v-if="!text">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #utmContent="{ text }">
          <span v-if="!text">--</span>
          <span v-else>{{text}}</span>
        </template>
        <template #regIp="{ text }">
          <span v-if="!text">--</span>
          <span v-else class="txt">
            <a-tooltip :title="text">{{text}}</a-tooltip>
          </span>
        </template>
        <template #platform="{ text }">
          <span v-if="!text">--</span>
          <span v-if="text === 1">App Store</span>
          <span v-if="text === 2">Google Play</span>
        </template>
      </a-table>
      <div class="page">
        <a-pagination
          :total="pageData.filterTotal"
          :show-total="total => `Total ${total} items`"
          :page-size="pageData.pageSize"
          v-model:current="pageData.current"
          @change="change"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, watchEffect, ref, toRefs } from "vue";
import { useStore } from "vuex";
import { QuestionCircleTwoTone } from "@ant-design/icons-vue";
export default {
  props: {
    modelRef: Object,
    tableData: Array,
    pageData: Object,
    countryData: Array,
    totalNum: Number,
    loadingObj: Object
  },
  setup(props, { attrs, slots, emit }) {
    const searchFrom = ref(null);
    const store = useStore();
    const onSubmit = e => {
      emit("onSubmit", "click");
    };
    // langdata :{'ko':{}, 'zh':{}}
    // langdata[item.lang.name]
    // 事件
    const fetchCountry = value => {
      emit("fetchCountry", value);
    };
    const resetFields = () => {
      emit("resetFields", searchFrom);
    };
    const downloadChange = () => {
      emit("downloadChange");
    };
    const state = reactive({
      langData: [],
      fetching: false
    });
    // form-item
    let methodData = [
        {
          name: "手机号",
          key: 1
        },
        {
          name: "邮箱",
          key: 2
        },
        {
          name: "facebook",
          key: 3
        }
      ],
      langData = ["zh", "ko"],
      deviceData = ["mobile", "web"];

    // table
    const columns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        key: "id",
        fixed: "left"
      },
      {
        title: "邮箱/手机号/第三方",
        dataIndex: "user",
        width: 160,
        key: "user",
        fixed: "left"
      },
      {
        title: "注册方式",
        dataIndex: "userType",
        key: "userType",
        width: 100,
        slots: { customRender: "userType" }
      },
      {
        title: "注册时间",
        dataIndex: "date",
        key: "date",
        width: 180
      },
      {
        title: "注册IP",
        dataIndex: "regIp",
        key: "regIp",
        width: 100,
        slots: { customRender: "regIp" }
      },
      {
        title: "国家/地区",
        dataIndex: "countryName",
        key: "countryName",
        width: 100,
        slots: { customRender: "countryName" }
      },
      {
        title: "utm_source",
        dataIndex: "utmSource",
        key: "utmSource",
        width: 120,
        slots: { customRender: "utmSource" }
      },
      {
        title: "utm_medium",
        dataIndex: "utmMedium",
        key: "utmMedium",
        width: 120,
        slots: { customRender: "utmMedium" }
      },
      {
        title: "utm_campaign",
        dataIndex: "utmCampaign",
        key: "utmCampaign",
        width: 130,
        slots: { customRender: "utmCampaign" }
      },
      {
        title: "utm_content",
        dataIndex: "utmContent",
        key: "utmContent",
        width: 120,
        slots: { customRender: "utmContent" }
      },
      {
        title: "语种",
        dataIndex: "language",
        key: "language",
        // width: 80
      },
      {
        title: "注册类型",
        dataIndex: "device",
        key: "device",
      },
      {
        title: (
          <div>
            预注册平台&nbsp;
            <a-tooltip
              placement="topLeft"
              title="根据每个游戏的预注册平台对应展示"
            >
              <QuestionCircleTwoTone />
            </a-tooltip>
          </div>
        ),
        dataIndex: "platform",
        key: "platform",
        ellipsis: true,
        // fixed: "right",
        slots: { customRender: "platform", title: "customTitle" }
      }
    ];
    // pagination
    const change = (page, pageSize) => {
      emit("pageChange", page, pageSize);
    };

    watchEffect(() => {
      // 语言赋值
      state.langData = store.state.settings.languages;
    });
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      onSubmit,
      methodData,
      langData,
      deviceData,
      columns,
      searchFrom,
      resetFields,
      downloadChange,
      change,
      fetchCountry,
      ...toRefs(state)
    };
  }
};
</script>


<style lang="less">
a[href="http://example.com"] {
  pointer-events: none;
}
.txt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  cursor: pointer;
  width: 85px;
}
.ant-table td {
  white-space: nowrap;
}
@import "./index.less";
</style>